import StateListenerRegistry from '../base/redux/StateListenerRegistry';
import { disableRaisehandModeration, enableRaisehandModeration, localParticipantApproved, localParticipantRejected, participantApproved, participantRejected } from './slice';
import { JitsiConferenceEvents } from '../base/lib-jitsi-meet';
/**
 * Registers a change handler for state['features/base/conference'].conference to
 * set the event listeners needed for the raise hand moderation feature to operate.
 */
StateListenerRegistry.register((state) => state['features/base/conference'].conference, (conference, { dispatch }, previousConference) => {
    if (conference && !previousConference) {
        conference.on(JitsiConferenceEvents.RAISE_HAND_MODERATION_APPROVED, ({ requestOccupantJid }) => {
            dispatch(localParticipantApproved());
        });
        conference.on(JitsiConferenceEvents.RAISE_HAND_MODERATION_REJECTED, () => {
            dispatch(localParticipantRejected());
        });
        conference.on(JitsiConferenceEvents.RAISE_HAND_MODERATION_CHANGED, ({ enabled, actor }) => {
            enabled ? dispatch(enableRaisehandModeration(actor)) : dispatch(disableRaisehandModeration(actor));
        });
        conference.on(JitsiConferenceEvents.RAISE_HAND_MODERATION_PARTICIPANT_APPROVED, ({ participant }) => {
            const { _id: jid } = participant;
            dispatch(participantApproved({ jid }));
        });
        conference.on(JitsiConferenceEvents.RAISE_HAND_MODERATION_PARTICIPANT_REJECTED, ({ participant }) => {
            const { _id: jid } = participant;
            dispatch(participantRejected({ jid }));
        });
    }
});
